import { motion } from "framer-motion";

const FOUNDER_STATS = [
  { value: "10+", label: "YEARS RUNNING LIFE INSIDE MEDIA" },
  { value: "03", label: "COMPANIES — LIM · LIME STUDIOS · LIMA" },
  { value: "EVERY", label: "BATCH, PERSONALLY MENTORED" },
];

function FounderPortrait() {
  return (
    <div className="relative" data-testid="founder-portrait">
      <span className="absolute -top-2 -left-2 w-6 h-6 border-t-2 border-l-2 border-lima-blue" aria-hidden="true" />
      <span className="absolute -top-2 -right-2 w-6 h-6 border-t-2 border-r-2 border-lima-blue" aria-hidden="true" />
      <span className="absolute -bottom-2 -left-2 w-6 h-6 border-b-2 border-l-2 border-lima-blue" aria-hidden="true" />
      <span className="absolute -bottom-2 -right-2 w-6 h-6 border-b-2 border-r-2 border-lima-blue" aria-hidden="true" />
      <div className="aspect-[4/5] bg-lima-navy border border-white/10 grid place-items-center relative overflow-hidden">
        <span className="font-serifd text-[9rem] md:text-[12rem] text-lima-blue/90 leading-none select-none" aria-hidden="true">AS</span>
        <span className="absolute bottom-4 left-4 font-mono2 text-[10px] tracking-[0.25em] text-white/70 bg-black/50 backdrop-blur px-2.5 py-1 border border-white/10">
          AMIT SINGH — FOUNDER
        </span>
        <span className="absolute top-4 right-4 w-2 h-2 bg-lima-red animate-rec" aria-hidden="true" />
      </div>
    </div>
  );
}

export default function FounderSection() {
  return (
    <section className="bg-lima-ink px-5 md:px-10 py-14 md:py-32 border-t border-white/10" data-testid="founder-section">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(12px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-4"
        >
          <FounderPortrait />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 30, filter: "blur(12px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="lg:col-span-8"
        >
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-lima-paper leading-[0.98]">
            Amit Singh <span className="font-serifit font-normal text-lima-blue">built the house first.</span>
          </h2>
          <p className="mt-3 font-mono2 text-xs tracking-[0.2em] text-white/40">
            FOUNDER — LIFE INSIDE MEDIA · LIME STUDIOS · LIMA
          </p>
          <div className="mt-8 space-y-5 max-w-2xl text-sm md:text-base text-white/60 leading-relaxed">
            <p>
              Ten-plus years ago, Amit founded <span className="text-white/85 font-semibold">Life Inside Media</span> —
              a Pune production house that has since delivered for national and multinational brands, including
              international clients. <span className="text-white/85 font-semibold">Lime Studios</span>, the pro-grade
              studio floor, came next.
            </p>
            <p>
              LIMA came last — because along the way he kept meeting film-school graduates who knew software but
              couldn't survive a real brief. So he built the academy he wished had existed: one inside a working
              production house, where the studio is the classroom.
            </p>
            <p className="font-serifit text-xl md:text-2xl text-[#6B73FF] leading-snug">
              "I don't teach from slides. I teach from call sheets."
            </p>
          </div>
          <div className="mt-10 grid grid-cols-3 border border-white/10 divide-x divide-white/10">
            {FOUNDER_STATS.map((s) => (
              <div key={s.label} className="p-4 md:p-6">
                <p className="font-serifd text-3xl md:text-4xl text-lima-blue leading-none">{s.value}</p>
                <p className="mt-2 font-mono2 text-[10px] md:text-[11px] tracking-[0.15em] text-white/40 leading-relaxed">{s.label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
